export const SerialFormatValidation = (formData) => {
    const errors = {};
    if (!formData.bnt_SerialRangeFrom) {
        errors.bnt_SerialRangeFrom = 'This field is required';
    }
    if (!formData.bnt_SerialRangeTo) {
        errors.bnt_SerialRangeTo = 'This field is required';
    }
    if (!formData.vc_SerialFormat) {
        errors.vc_SerialFormat = 'This field is required';
    }
    return errors;
};

